// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.app-search-input {
  background-color: var(--color-input-background);
  color: var(--color-content-base);
  box-shadow: 0 0 0 1px var(--color-border-base), 0px -1px 1px var(--color-border-base);
  line-height: 32px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  border: none;
  height: 32px;
  width: 200px;
}
.app-search-input--disabled {
  opacity: 0.5;
}
.app-search-input--plain {
  box-shadow: none;
}
.app-search-input--hide-arrows::-webkit-outer-spin-button,
.app-search-input--hide-arrows::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Chrome & Safari */
}
.app-search-input--hide-arrows[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}
.app-search-input--error {
  box-shadow: 0 0 0 1px var(--color-error-shadow-base), 0px -1px 1px var(--color-error-shadow-base);
  background-color: var(--color-error-background-base);
}
.app-search-input--variant-small {
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
}
.app-search-input--variant-medium {
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
}
.app-search-input--variant-large {
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
}
.app-search-input--focused,
.app-search-input:focus {
  outline-offset: 2px;
  outline: 2px solid var(--color-outline-base);
}
.app-search-input input {
  flex: 1;
  min-width: 20px;
  border: none;
  box-shadow: none;
  background-color: transparent;
}
.app-search-input--variant-secondary {
  border: none;
  box-shadow: none;
}
.app-search-input__help-button,
.app-search-input__clear-button {
  width: 30px;
  line-height: 20px;
  color: var(--color-content-subdued);
  text-align: center;
  cursor: pointer;
}
.app-search-input--without-border {
  box-shadow: none;
}
.app-search-input--size-medium .app-search-input__clear-button {
  line-height: 30px;
}
.app-search-input--size-small {
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
}
.app-search-input--invalid-value {
  color: var(--color-error-content-base);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/common/ui/search-input/SearchInput.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/input.less","webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/misc.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;ECCE,+CAAA;EACA,gCAAA;EACA,qFAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EDNA,YAAA;AAgBF;ACJE;EACE,YAAA;ADMJ;ACHE;EACE,gBAAA;ADKJ;ACDI;;EAEE,wBAAA;EDGJ,oBAAoB;AACtB;ACDI;EACE,0BAAA;EDGJ,YAAY;AACd;ACAE;EACE,iGAAA;EACA,oDAAA;ADEJ;ACCE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADCJ;ACEE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADAJ;ACGE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ADDJ;ACIE;;EC1DA,mBAAA;EACA,4CAAA;AF0DF;AA1DA;EAMI,OAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;AAuDJ;AApDE;EACE,YAAA;EACA,gBAAA;AAsDJ;AAnDE;;EAEE,WAAA;EACA,iBAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;AAqDJ;AAlDE;EACE,gBAAA;AAoDJ;AAjDE;EACE,iBAAA;AAmDJ;AAhDE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;AAkDJ;AA/CE;EACE,sCAAA;AAiDJ","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.app-search-input {\n  .neptune-input(@with-padding: false);\n  \n  width: 200px;\n\n  input {\n    flex: 1;\n    min-width: 20px;\n    border: none;\n    box-shadow: none;\n    background-color: transparent;\n  }\n\n  &--variant-secondary {\n    border: none;\n    box-shadow: none;\n  }\n\n  &__help-button,\n  &__clear-button {\n    width: 30px;\n    line-height: 20px;\n    color: var(--color-content-subdued);\n    text-align: center;\n    cursor: pointer;\n  }\n\n  &--without-border {\n    box-shadow: none;\n  }\n\n  &--size-medium &__clear-button {\n    line-height: 30px;\n  }\n\n  &--size-small {\n    height: @layoutUnit-lg;\n    line-height: @layoutUnit-lg;\n    border-radius: 4px;\n  }\n\n  &--invalid-value {\n    color: var(--color-error-content-base);\n  }\n}\n","@import \"./../variables.less\";\n\n.neptune-input(@with-padding: true) {\n  background-color: var(--color-input-background);\n  color: var(--color-content-base);\n  box-shadow: @input-box-shadow;\n  line-height: 32px;\n  font-size: @fontSize-sm;\n  font-weight: @fontWeight-regular;\n  border-radius: @input-border-radius;\n  border: none;\n  height: 32px;\n\n  & when (@with-padding = true) {\n    padding: 0 5px;\n  }\n\n  &--disabled {\n    opacity: 0.5;\n  }\n\n  &--plain {\n    box-shadow: none;\n  }\n\n  &--hide-arrows {\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none; /* Chrome & Safari */\n    }\n\n    &[type=number] {\n      -moz-appearance: textfield; /* Firefox */\n    }\n  }\n\n  &--error {\n    box-shadow: @input-box-shadow-error;\n    background-color: @input-bg-error;\n  }\n\n  &--variant-small {\n    height: @layoutUnit-lg;\n    line-height: @layoutUnit-lg;\n    border-radius: 4px;\n  }\n\n  &--variant-medium {\n    height: @layoutUnit-xl;\n    line-height: @layoutUnit-xl;\n    border-radius: 4px;\n  }\n\n  &--variant-large {\n    height: @layoutUnit-xxl;\n    line-height: @layoutUnit-xxl;\n    border-radius: 4px;\n  }\n\n  &--focused,\n  &:focus {\n    .n-outline();\n  }\n}\n\n.neptune-input-select() {\n  .neptune-input(@with-padding: false);\n\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n\n  user-select: none;\n\n  padding: 6px 8px;\n\n  &[data-placeholder] {\n    color: var(--color-content-secondary);\n  }\n\n  &__icon {\n    color: var(--color-content-secondary);\n  }\n}\n",".n-outline() {\n  outline-offset: 2px;\n  outline: 2px solid var(--color-outline-base);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
